import DatePicker from "react-datepicker";
import { getMonth, getYear } from "date-fns";
import range from "lodash/range";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from "react";
import dateRange from "./../../../utils/helpers/dateRange";
import { getObjectKeys } from "../../../utils/validators/validators";
import { convertDate } from "../../../utils/helpers/filter";

const InputDate = ({
  state,
  setState,
  error,
  setError,
  className,
  name,
  textname,
  defaultDate,
}) => {
  const [dateNow, getDateRange] = dateRange();
  let date = new Date();
  const monthIndex = date.getMonth();
  const dayIndex = date.getDate();
  let startFrom = date.getFullYear();
  const [startDate, setStartDate] = useState(
    new Date(startFrom - 18, monthIndex, dayIndex)
  );
  // const years = range(2004, getYear(new Date()) + 1, 1);
  const years = range(startFrom - 18 - 50, startFrom - 18 + 1, 1);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  // let currentDefaultDate = new Date(defaultDate)
  useEffect(() => {
    // setState({...state, d_o_b: startDate})
    // let newDate = new Date(defaultDate).toLocaleDateString()
  }, [startDate, years, months]);

  return (
    <DatePicker
      textname={textname}
      name={name}
      className={className}
      renderCustomHeader={({ date, changeYear, changeMonth }) => (
        <div
          style={{
            margin: 10,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <select
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
      )}
      selected={defaultDate ? new Date(defaultDate) : startDate}
      onChange={(date) => {
        setState({ ...state, d_o_b: convertDate(date) });
        setStartDate(date);
        // remove item from state object using key
        if (getObjectKeys(error).length !== 0) {
          setError((current) => {
            const copy = { ...current };
            delete copy[name];
            return copy;
          });
        }
      }}
    />
  );
};

export default InputDate;
